"use client";
import {
  useMenuContext
} from "../__chunks/B2J376ND.js";
import "../__chunks/62UHHO2X.js";
import {
  useCompositeSeparator
} from "../__chunks/TP7N7UIH.js";
import "../__chunks/A3CZKICO.js";
import "../__chunks/P7GR5CS5.js";
import "../__chunks/VDHZ5F7K.js";
import "../__chunks/EM5CXX6A.js";
import "../__chunks/MTZPJQMC.js";
import "../__chunks/RS7LB2H4.js";
import "../__chunks/S6EF7IVO.js";
import {
  createElement,
  createHook,
  forwardRef
} from "../__chunks/LMDWO4NN.js";
import "../__chunks/ABQUS43J.js";
import "../__chunks/SK3NAZA3.js";
import {
  __objRest,
  __spreadValues
} from "../__chunks/3YLGPPWQ.js";

// src/menu/menu-separator.tsx
var TagName = "hr";
var useMenuSeparator = createHook(
  function useMenuSeparator2(_a) {
    var _b = _a, { store } = _b, props = __objRest(_b, ["store"]);
    const context = useMenuContext();
    store = store || context;
    props = useCompositeSeparator(__spreadValues({ store }, props));
    return props;
  }
);
var MenuSeparator = forwardRef(function MenuSeparator2(props) {
  const htmlProps = useMenuSeparator(props);
  return createElement(TagName, htmlProps);
});
export {
  MenuSeparator,
  useMenuSeparator
};
